// api
/**
 * demo
 * 获取用户信息
 */
import {baseUrl} from '@/dicts/apiUrl';


// 3.1. 服务管理/用户状态接口
// 接口地址：/v1/service_info
export const getServiceInfoApi = baseUrl + 'service_info';

// 3.2. 申请试用接口
// 3.2.1. 申请状态
export const getApplyStatusApi = baseUrl + 'apply/status';
// 3.2.2. 提交申请
export const getApplyAddApi = baseUrl + 'apply/add';

// 3.3. 报表：支持单天 、多天选择，支持按 CaptchaID 查询
// 3.3.1. 数据统计
export const getStatsSummaryApi = baseUrl + 'stats/summary';
// 3.3.2. 趋势图：交互总统计
export const getStatsTrendApi = baseUrl + 'stats/trend';
// 3.3.3. 趋势图：交互按类型统计
export const getStatsTrendByTypeApi = baseUrl + 'stats/trend_by_type';

// 3.4. 场景管理
// 3.4.1. 已有的 CaptchaID 列表
export const getSceneListIdApi = baseUrl + 'scene/list-id';
// 3.4.2. 场景列表：详情并支持分页
export const getSceneListApi = baseUrl + 'scene/list';
// 3.4.3. 查看场景详情
export const getSceneInfoApi = baseUrl + 'scene/info';
// 3.4.4. 新建场景
export const getSceneAddApi = baseUrl + 'scene/add';
// 3.4.5. 编辑场景
export const getSceneUpdateApi = baseUrl + 'scene/update';
// 3.4.6. 删除场景
export const getSceneDeleteApi = baseUrl + 'scene/delete';

// 3.5. 告警管理
// 告警配置：支持的告警对象列表：请求量、验证量、验证通过量、验证拦截量、验证拦截率
// 3.5.1. 告警规则-列表：分页，支持按 CaptchaID 查询并分页
export const getAlertRuleListApi = baseUrl + 'alert/rule/list';
// 3.5.2. 告警规则-详情
export const getAlertRuleInfoApi = baseUrl + 'alert/rule/info';
// 3.5.3. 告警规则-新增
export const getAlertRuleAddApi = baseUrl + 'alert/rule/add';
// 3.5.4. 告警规则-编辑
export const getAlertRuleUpdateApi = baseUrl + 'alert/rule/update';
// 3.5.5. 告警规则-删除
export const getAlertRuleDeleteApi = baseUrl + 'alert/rule/delete';
// 3.5.6. 告警规则启停
export const getAlertRuleControlApi = baseUrl + 'alert/rule/control';
// 3.5.7. 告警信息列表
export const getAlertInfoListApi = baseUrl + 'alert/list';

// 3.6. 日志查询
// 3.6.1. 查询日志列表
export const getLogListApi = baseUrl + 'log';

// 下单
// 询价
export const getPriceV3Order = '/api/price/v3/order';
export const getOrderPrepayApi = baseUrl + 'billing/order/prepay';
